export const supportedLanguages = ["en", "zh", "ja"] as const;

export type LanguageCode = (typeof supportedLanguages)[number];

export const languageSwitcherOptions: Array<{
  code: LanguageCode;
  label: string;
  shortLabel: string;
}> = [
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "zh", label: "中文", shortLabel: "中文" },
  { code: "ja", label: "日本語", shortLabel: "日本語" },
];

export const normalizeLanguageCode = (language?: string | null): LanguageCode => {
  const baseLanguage = language?.toLowerCase().split("-")[0];
  return supportedLanguages.includes(baseLanguage as LanguageCode)
    ? (baseLanguage as LanguageCode)
    : "en";
};

export const languageDateLocales: Record<LanguageCode, string> = {
  en: "en-US",
  zh: "zh-CN",
  ja: "ja-JP",
};
